module.exports = __webpack_public_path__ + "99cfde958ba2eccf056c189b087453ea.pdf";